@use "stylesheets/utility/variables";

.wrapper {
  width: 100%;
  height: calc(100dvh - variables.$primary-header-height-mobile);
  position: fixed;
  top: variables.$primary-header-height-mobile;
  z-index: 1;

  @media (max-width: variables.$laptop) {
    z-index: 100;
  }
}

.overlay {
  width: 100%;
  height: calc(100dvh - variables.$primary-header-height-mobile);
  background: var(--fill-neutral);
  opacity: 0.6;
}

.content {
  display: flex;
  max-width: 315px;
  width: 100%;
  height: calc(100dvh - variables.$primary-header-height-mobile);
  background: var(--bg-default);
  overflow: auto;
  position: absolute;
  top: 0;
}

.right {
  right: 0;
}
